import React from 'react';
import bem from 'utils/bem';
import toast from 'react-hot-toast';
import { Formik } from 'formik';
import Text from 'components/Text';
import { Button } from 'components/Button';
import TextField from 'forms/fields/TextField';
import { updateCustomerBalance } from 'api/user';
import Model from '../../../../model';
import './index.sass';

const { block, el } = bem('update-balance-form', 'form');

const defaultValues = {
    code: '',
};

const UpdateBalanceForm = () => {

    const { username, user: { balance: oldBalance } } = Model.user;
    const { closeUpdateBalanceForm } = Model.modal;

    const handleSubmit = async (values, form) => {

        const variables = {
            phone: username,
            code: values.code
        }

        try {
            const { error, newBalance } = await updateCustomerBalance(variables);
            Model.user.updateUserInfo();
            if (error) {
                throw error;
            }
            if (newBalance && newBalance > oldBalance) {
                toast.success('Ваш баланс успешно пополнен');
                Model.user.updateUserInfo();
                closeUpdateBalanceForm();
            }
        } catch (err) {
            console.log(err);
            toast.error(`Произошла ошибка при пополнении баланса: ${ err }`);
            form.setSubmitting(false)
        }
    };

    const rForm = (form) => {
        return (
            <form className={ block() } onSubmit={ form.handleSubmit }>
                <div className={ el('title') }>
                    <Text serif>Пополнение баланса</Text>
                </div>
                <div className={ el('fields') }>
                    <div className={ el('code') }>
                        <TextField name={ 'code' } placeholder={ 'Код сертификата' }/>
                    </div>
                </div>
                <div className={ el('buttons') }>
                    <Button mod={ 'gold' }
                            type='submit'
                            disabled={ form.isSubmitting }>
                        <Text>Применить</Text>
                    </Button>
                </div>
            </form>
        )
    }

    return (
        <Formik
            initialValues={ defaultValues }
            onSubmit={ handleSubmit }
            isInitialValid={ false }
            validateOnChange={ true }
            validateOnBlur={ false }>
            { (form) => rForm(form) }
        </Formik>
    )
};

export default UpdateBalanceForm;
